document.addEventListener("DOMContentLoaded", function () {
  const quoteSlider = document.querySelector(".quoteSlider");

  if (quoteSlider) {

    const quoteSliderGlide = document.querySelector(".quoteSlider__glide");
    const quoteSliderBtns = document.querySelectorAll(".quoteSlider-arrow");
    const quoteSliderBulletsContainer = quoteSlider.querySelector(".quoteSlider__bullets");
    const quoteSliderSlides = quoteSlider.querySelectorAll(".glide__slide:not(.glide__slide--clone)");

    if (quoteSliderSlides.length > 1) {

      if (quoteSliderGlide) {
        const glide = new Glide(quoteSliderGlide, {
          type: 'carousel',
          autoplay: 5000,
          hoverpause: true,
          loop: false,
          gap: 20,
          perView: 1,
          animationTimingFunc: "ease-in-out",
          animationDuration: 800,
          pagination: {
            el: quoteSliderBulletsContainer,
            clickable: true,
          },
        });

        let currentIndex = 0;

        glide.mount();

        quoteSliderBtns.forEach(button => {
          button.addEventListener("click", () => {
            currentIndex = glide.index;
            glide.go(button.classList.contains("quoteSlider-prev") ? '<' : '>');
          });
          button.addEventListener("keydown", event => {
            if (event.key === "Enter") {
              currentIndex = glide.index;
              glide.go(button.classList.contains("quoteSlider-prev") ? '<' : '>');
            }
          });
        });

        glide.on('run', function () {
          currentIndex = glide.index;
          // Remove active class from all bullets
          quoteSliderBulletsContainer.querySelectorAll("button").forEach(bullet => {
            bullet.classList.remove("active");
          });

          // Add active class to the corresponding bullet
          const correspondingBullet = quoteSliderBulletsContainer.querySelector(`button[data-glide-dir="=${currentIndex}"]`);
          if (correspondingBullet) {
            correspondingBullet.classList.add("active");
          }
        });

        // Dynamically create and add buttons for each slide
        quoteSliderSlides.forEach((slide, index) => {
          const button = document.createElement("button");
          button.classList.add("glide__bullet", "quoteSlider__bullet");
          button.setAttribute("data-glide-dir", "=" + index);
          button.setAttribute("aria-label", "Slider Bullet for Quote " + index);
          quoteSliderBulletsContainer.appendChild(button);
        });

        // Add active class to the first bullet initially
        const firstBullet = quoteSliderBulletsContainer.querySelector("button");
        if (firstBullet) {
          firstBullet.classList.add("active");
        }

        const quoteSliderBullets = quoteSlider.querySelectorAll(".quoteSlider__bullet");

        quoteSliderBullets.forEach((bullet) => {
          bullet.addEventListener("click", () => {
            let slideTo = bullet.getAttribute("data-glide-dir");
            glide.go(slideTo);
          });
          bullet.addEventListener("keydown", event => {
            if (event.key === "Enter") {
              let slideTo = bullet.getAttribute("data-glide-dir");
              glide.go(slideTo);
            }
          });
        });
      }

    } else {
      // Hide arrows and bullets if only one slide
      quoteSliderBtns.forEach(button => {
        button.style.display = "none";
      });
      if (quoteSliderBulletsContainer) {
        quoteSliderBulletsContainer.style.display = "none";
      }
    }

  }
});
